import ComponentManager from '@/Management/ComponentManager';
import ChipsHelper from '@/Utility/ChipsHelper';

export default class FilterChipsHelper {

    private static publicPrefix = 'g_';
    private static privatePrefix = 'p_';
    private static customPrefix = 'c_';

    public static isPrivate(id: string): boolean {
        return id?.startsWith(FilterChipsHelper.privatePrefix);
    }

    public static isPublic(id: string): boolean {
        return id?.startsWith(FilterChipsHelper.publicPrefix);
    }

    public static isCustom(id: string): boolean {
        return id?.startsWith(FilterChipsHelper.customPrefix);
    }

    public static addPrivatePrefix(id: string) {
        return FilterChipsHelper.privatePrefix + id;
    }

    public static addPublicPrefix(id: string) {
        return FilterChipsHelper.publicPrefix + id;
    }

    public static addCustomPrefix(id: string) {
        return FilterChipsHelper.customPrefix + id;
    }

    public static removePrivatePrefix(id: string) {
        return id?.substring(FilterChipsHelper.privatePrefix.length);
    }

    public static removePublicPrefix(id: string) {
        return id?.substring(FilterChipsHelper.publicPrefix.length);
    }

    public static removeCustomPrefix(id: string) {
        return id?.substring(FilterChipsHelper.customPrefix.length);
    }

    public static getValues(value: string, showPublicOnly: boolean = false, showPrivateOnly: boolean = false): string[] {
        const values = ChipsHelper.getValues(value);

        // Ob private/public-Filter: Der Custom-Chip muss immer angezeigt werden!!
        if (showPublicOnly) {
            return values.filter(f => (this.isPublic(f) || this.isCustom(f)));
        }
        else if (showPrivateOnly) {
            return values.filter(f => (this.isPrivate(f) || this.isCustom(f)));
        }

        return values;
    }

    public static getValuesAlphabetically(value: string, showPublicOnly: boolean = false, showPrivateOnly: boolean = false): string[] {
        const values = FilterChipsHelper.getValues(value, showPublicOnly, showPrivateOnly);

        return values.sort((a: string, b: string) => {
            let aString = a.toString();
            let bString = b.toString();

            if (aString.startsWith(this.privatePrefix) && bString.startsWith(this.publicPrefix)) {
                return -1;
            }
            if (aString.startsWith(this.publicPrefix) && bString.startsWith(this.privatePrefix)) {
                return 1;
            }

            return aString.localeCompare(bString, undefined, { numeric: true });
        });
    }

    private static count(text, value): number {
        return (text.match(new RegExp(value, 'g')) || []).length;
    }
}

ComponentManager.setUtility('ChipsHelper', FilterChipsHelper, 'RADPresentation.HTMLClient.DefaultViewExtensions');